/* Southern Atelier – product listing: live filtering (Section Rendering API), drawers, load more */
(() => {
  if (window.__saPlp) return;
  window.__saPlp = true;

  const lock = (on) => document.documentElement.classList.toggle('sa-lock', on);

  function sectionUrl(url, sectionId) {
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  async function render(plp, url, { push = true, scrollTop = false } = {}) {
    const id = plp.dataset.sectionId;
    plp.classList.add('is-loading');
    try {
      const html = await fetch(sectionUrl(url, id)).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-sa-plp]');
      if (!fresh) return;
      // keep open drawer / dropdown state
      const openDrawer = plp.querySelector('[data-sa-fdrawer]:not([hidden])')?.dataset.saFdrawer;
      const openDrops = [...plp.querySelectorAll('details[open]')].map((d) => d.querySelector('summary')?.textContent.trim());
      plp.replaceWith(fresh);
      if (openDrawer) { const d = fresh.querySelector(`[data-sa-fdrawer="${openDrawer}"]`); if (d) { d.hidden = false; lock(true); } }
      fresh.querySelectorAll('details').forEach((d) => { if (openDrops.includes(d.querySelector('summary')?.textContent.trim()) && d.closest('[data-sa-fdrawer]')) d.open = true; });
      init(fresh);
      if (push) history.pushState({ saPlp: true }, '', url);
      if (scrollTop) fresh.scrollIntoView({ behavior: 'smooth' });
    } finally {
      plp.classList.remove('is-loading');
    }
  }

  function formUrl(form) {
    const fd = new FormData(form);
    const params = new URLSearchParams();
    for (const [k, v] of fd.entries()) {
      if (v === '' || k === 'sort_by_m') continue;
      params.append(k, v);
    }
    return form.getAttribute('action') + '?' + params.toString();
  }

  function init(plp) {
    const form = plp.querySelector('[data-sa-filter-form]');
    if (!form) return;
    let t;
    form.addEventListener('change', (e) => {
      const el = e.target;
      if (el.matches('[data-sa-sort-mirror]')) {
        const r = form.querySelector(`input[name="sort_by"][value="${el.value}"]`);
        if (r) r.checked = true;
      }
      // mirror desktop/mobile checkbox of the same value
      if (el.type === 'checkbox') {
        form.querySelectorAll(`input[type=checkbox][name="${CSS.escape(el.name)}"][value="${CSS.escape(el.value)}"]`).forEach((o) => { o.checked = el.checked; });
      }
      if (el.matches('[data-sa-price]')) {
        form.querySelectorAll(`[data-sa-price][name="${CSS.escape(el.name)}"]`).forEach((o) => { o.value = el.value; });
      }
      // de-duplicate: only keep one copy of each param (desktop scope)
      clearTimeout(t);
      t = setTimeout(() => {
        const scope = el.dataset.saScope === 'm' ? 'd' : 'm';
        form.querySelectorAll(`[data-sa-scope="${scope}"]`).forEach((o) => { o.disabled = true; });
        const url = formUrl(form);
        form.querySelectorAll(`[data-sa-scope="${scope}"]`).forEach((o) => { o.disabled = false; });
        render(plp, url);
      }, el.matches('[data-sa-price]') ? 600 : 50);
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); });

    plp.querySelectorAll('[data-sa-filter-link]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); render(plp, a.href); }));

    // dropdowns: one open at a time, close on outside click
    const drops = plp.querySelectorAll('[data-sa-dropdown]');
    drops.forEach((d) => d.addEventListener('toggle', () => { if (d.open) drops.forEach((o) => { if (o !== d) o.open = false; }); }));
    document.addEventListener('click', (e) => { drops.forEach((d) => { if (!d.contains(e.target)) d.open = false; }); });

    // drawers
    plp.querySelectorAll('[data-sa-fdrawer-open]').forEach((b) => b.addEventListener('click', () => {
      const d = plp.querySelector(`[data-sa-fdrawer="${b.dataset.saFdrawerOpen}"]`);
      if (d) { d.hidden = false; lock(true); }
    }));
    plp.querySelectorAll('[data-sa-fdrawer-close]').forEach((b) => b.addEventListener('click', () => {
      b.closest('[data-sa-fdrawer]').hidden = true; lock(false);
    }));

    // load more
    const more = plp.querySelector('[data-sa-next-page]');
    more?.addEventListener('click', async (e) => {
      e.preventDefault();
      more.setAttribute('aria-disabled', 'true');
      const html = await fetch(sectionUrl(more.href, plp.dataset.sectionId)).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = plp.querySelector('[data-sa-grid]');
      doc.querySelectorAll('[data-sa-grid] > li').forEach((li) => grid.appendChild(li));
      const lm = doc.querySelector('[data-sa-loadmore]');
      plp.querySelector('[data-sa-loadmore]').replaceWith(lm);
      window.saWishlist?.sync();
      init2(plp);
    });
  }
  // re-bind only load more after append
  function init2(plp) {
    const more = plp.querySelector('[data-sa-next-page]');
    if (!more) return;
    more.addEventListener('click', async (e) => {
      e.preventDefault();
      more.setAttribute('aria-disabled', 'true');
      const html = await fetch(sectionUrl(more.href, plp.dataset.sectionId)).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = plp.querySelector('[data-sa-grid]');
      doc.querySelectorAll('[data-sa-grid] > li').forEach((li) => grid.appendChild(li));
      plp.querySelector('[data-sa-loadmore]').replaceWith(doc.querySelector('[data-sa-loadmore]'));
      window.saWishlist?.sync();
      init2(plp);
    });
  }

  window.addEventListener('popstate', () => {
    const plp = document.querySelector('[data-sa-plp]');
    if (plp) render(plp, location.href, { push: false });
  });

  const boot = () => document.querySelectorAll('[data-sa-plp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
